import { EnglishArabicDTO } from "bbsf-controls"
export class EmailTemplateInfoDTO
{
      ID:number
      EmailSubject :EnglishArabicDTO=new EnglishArabicDTO();
      EmailBody :EnglishArabicDTO=new EnglishArabicDTO();
      TemplateEmailBaseHeader :EnglishArabicDTO=new EnglishArabicDTO();
      TemplateEmailBaseFooter :EnglishArabicDTO=new EnglishArabicDTO();
      EmailHtmlBodyTagAttributes :EnglishArabicDTO=new EnglishArabicDTO();
      EmailHtmlHeadSection :EnglishArabicDTO=new EnglishArabicDTO();
      IsMoveCssInline :boolean
      LanguageModeItemID:number
      LanguageModeItemName:string
      TemplateEmailBaseID?:number
      TemplateEmailBaseName:string
}
     